import JSResource from './jsresource'

const { VITE_CHAT_ROUTE, VITE_AUTOHINT_ROUTE } = import.meta.env

// NOTE: In order to rerender translations on language change each component rendered by route must have useSelector with internationalization inside
const routes = [
  {

    component: JSResource('App', () => import('./components/app/app')),

    // The App component does not depend on external data so does not preload any.
    prepare: () => { return {} },

    routes: [
      {
        path: '/',
        exact: true,

        component: JSResource('Chat', () => import('./components/landing-root/landing-root')),

        prepare: () => { }
      },
      {
        // This is the entry point for the PowerPoint add-in task pane. Refer to manifest.xml under Taskpane.Url.
        path: '/index.html',
        exact: true,

        component: JSResource('Welcome', () => import('./components/welcome/welcome')),

        prepare: () => { }
      },
      {
        path: '/verify-landing-root',
        exact: true,

        component: JSResource('VerifyLandingRoot', () => import('./components/verify-landing-root/verify-landing-root')),

        prepare: () => { }
      },
      {
        path: VITE_AUTOHINT_ROUTE,
        exact: true,

        component: JSResource('AutoHint', () => import('./components/autohint/autohint')),

        prepare: () => { }
      },
      {
        path: `${VITE_CHAT_ROUTE}:stream_guid`,
        exact: true,

        // A lazy reference to the component for the home route. Note that we intentionally don't
        // use React.lazy here: that would start loading the component only when it's rendered.
        // By using a custom alternative we can start loading the code instantly. This is
        // especially useful with nested routes, where React.lazy would not fetch the
        // component until its parents code/data had loaded.
        component: JSResource('HomeRoot', () => import('./components/home-root/home-root')),

        // A function to prepare the data for the `component` in parallel with loading
        // that component code. The actual data to fetch is defined by the component
        // itself - here we just reference a description of the data - the generated query.
        // Below is a sample to show how to preload route data.
        // prepare: (params: { stream_guid: string }) => {
        //   const preloadableRequest: GraphQLTaggedNode = require('./components/home-root/__generated__/homeRootQuery.graphql')
        //   const variables: homeRootQuery$variables = {
        //     stream_guid: params.stream_guid,
        //   }

        //   return {
        //     preloadedQuery: loadQuery<homeRootQuery>(
        //       environment,
        //       preloadableRequest,
        //       variables,
        //       { fetchPolicy: 'store-or-network' },
        //     ),
        //   }
        // },
        prepare: () => { }
      },
      {
        // To learn more about the route configuration, please refer to the comments above.
        path: '/accounts/:provider/login/callback',
        exact: true,
        component: JSResource('HomeRoot', () => import('./components/home-root/home-root')),
        prepare: () => { return {} },
      },
      {
        path: '/',
        exact: false,
        component: JSResource('Error', () => import('./components/error/error')),
        prepare: () => { }
      }
    ],
  },
]

export default routes

export type Routes = typeof routes
